'use client';

import React from 'react';
import Image from 'next/image';
import {Decoration} from '@/_application/modules/not-found/types/not-found.types';
import styles from './not-found-background-layer.module.css';
import {useMovingDecorations} from './use-moving-decorations';

interface NotFoundBackgroundLayerDesktopProps {
    desktopDecoration: Decoration[];
}

const NotFoundBackgroundLayerDesktop: React.FC<NotFoundBackgroundLayerDesktopProps> = ({desktopDecoration}) => {
    const {containerRef, items, decorations} = useMovingDecorations({
        decorations: desktopDecoration,
        defaultWidth: 130,
        defaultHeight: 130,
    });

    return (
        <div ref={containerRef} className={styles.container}>
            {decorations.map((decoration, index) => {
                const item = items[index];
                if (!item) return null;

                return (
                    <div
                        key={`desktop-${decoration.alt}-${index}`}
                        className={styles.item}
                        style={{
                            transform: `translate(${item.x}px, ${item.y}px) rotate(${item.rotation}deg)`,
                            width: item.width,
                            height: item.height,
                        }}>
                        <Image
                            src={decoration.src}
                            alt={decoration.alt}
                            width={item.width}
                            height={item.height}
                            className={styles.image}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default NotFoundBackgroundLayerDesktop;
